import type { ReactNode } from "react"

import { Badge } from "../Badge"
import { Box } from "../Box"
import { Icon, type IconName } from "../Icon"
import { Text } from "../Text"
import styles from "./RadioBigCard.module.css"
import { useRadioGroup } from "./RadioGroup"
import { RadioItem } from "./RadioItem"

export interface RadioBigCardProps {
  value: string
  icon: IconName
  title: string
  description?: string
  badge?: {
    title: string
  }
  footer?: ReactNode
  disabled?: boolean
  grow?: boolean
}

export function RadioBigCard(props: RadioBigCardProps) {
  const {
    value,
    icon,
    title,
    description,
    badge,
    footer,
    disabled = false,
    grow = false,
  } = props

  const { selectedValue } = useRadioGroup()

  const isSelected = selectedValue === value

  return (
    <RadioItem value={value} disabled={disabled} grow={grow}>
      <div className={styles.radioBigCard}>
        <div className={styles.iconContainer}>
          <Icon
            name={icon}
            size="large"
            color={isSelected ? "purple9" : "grey9"}
          />
        </div>
        <div className={styles.content}>
          <Text variant="h4" color="grey12" align="center">
            {title}
          </Text>
          {description && (
            <Text
              variant="normal"
              color="grey11"
              align="center"
              sx={{ marginTop: 6 }}
            >
              {description}
            </Text>
          )}
          {badge && (
            <Badge
              size="medium"
              color={disabled ? "grey" : "purple"}
              title={badge.title}
              sx={{ marginTop: 16 }}
            />
          )}
          {footer && (
            <Box
              margin={{ top: 16 }}
              flexDirection="column"
              alignItems="center"
            >
              {footer}
            </Box>
          )}
        </div>
      </div>
    </RadioItem>
  )
}
